import { toast } from "react-toastify";
import axiosInstance from "../../../../../axiosInstance";
import { HRMS_EMPLOYEE_API_URL } from "../../../../Constants/baseConstant";
import { getDomain, getEmployeeId, getUserId } from "../../../Base/helper/baseFunctions";
import { validateEmailHelper } from "../../../SignIn/helper/SigninHelper";

// ── Get Org Type (single/multiple toggle) ───────────────────────────────────
export const GetVMOrgTypeHelper = async (params) => {
    return await axiosInstance(`/visitors/getVMOrgType`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: params?.domain_name || getDomain(),
        },
    })
        .then((res) => {
            return { message: "Org type retrieved successfully", hasError: false, data: res?.data };
        })
        .catch((err) => {
            return { message: "Unable to retrieve org type", hasError: true, data: err?.response?.data };
        });
};

// ── Update Org Type (toggle single/multiple) ─────────────────────────────────
export const UpdateVMOrgTypeHelper = async (params) => {
    toast.dismiss();
    toast.info("Saving...");
    return await axiosInstance(`/visitors/updateVMOrgType`, {
        method: "PUT",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            user_empid: getEmployeeId(),
            vm_org_type_single: params?.vm_org_type_single,
        },
    })
        .then((res) => {
            toast.dismiss();
            toast.success("Org type updated successfully");
            return { message: "Org type updated successfully", hasError: false, data: res?.data };
        })
        .catch((err) => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message);
            return { message: "Unable to update org type", hasError: true, data: err?.response?.data };
        });
};

// ── Get Multiple Org Configuration ───────────────────────────────────────────
export const GetVMMultipleOrgConfigurationHelper = async (params) => {
    return await axiosInstance(`/visitors/getVMMultipleOrgConfiguration`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: params?.domain_name || getDomain(),
        },
    })
        .then((res) => {
            return { message: "Org configurations retrieved successfully", hasError: false, data: res?.data };
        })
        .catch((err) => {
            return { message: "Unable to retrieve org configurations", hasError: true, data: err?.response?.data };
        });
};

// ── Upsert Multiple Org Configuration ────────────────────────────────────────
export const UpsertVMMultipleOrgConfigurationHelper = async (params) => {
    toast.dismiss();
    toast.info("Saving...");
    return await axiosInstance(`/visitors/upsertVMMultipleOrgConfiguration`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            multiple_org_configuration_pk: params?.multiple_org_configuration_pk || null,
            org_name: params?.org_name,
            contact_person_name: params?.contact_person_name,
            contact_mobile_number: params?.contact_mobile_number || "",
            contact_email: params?.contact_email,
            org_department: params?.org_department || "",
        },
    })
        .then((res) => {
            toast.dismiss();
            toast.success(params?.multiple_org_configuration_pk ? "Organization updated successfully" : "Organization added successfully");
            if(!params?.multiple_org_configuration_pk) {
                validateEmailHelper({ domain: getDomain(), email: params?.contact_email  })
            }
            return { message: "Organization saved successfully", hasError: false, data: res?.data };
        })
        .catch((err) => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message);
            return { message: "Unable to save organization", hasError: true, data: err?.response?.data };
        });
};

// ── Delete Multiple Org Configuration ────────────────────────────────────────
export const DeleteVMMultipleOrgConfigurationHelper = async (params) => {
    toast.dismiss();
    toast.info("Deleting...");
    return await axiosInstance(`/visitors/deleteVMMultipleOrgConfiguration`, {
        method: "DELETE",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            multiple_org_configuration_pk: params?.multiple_org_configuration_pk,
        },
    })
        .then((res) => {
            toast.dismiss();
            toast.success("Organization deleted successfully");
            return { message: "Organization deleted successfully", hasError: false, data: res?.data };
        })
        .catch((err) => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message);
            return { message: "Unable to delete organization", hasError: true, data: err?.response?.data };
        });
};
